import { render } from "./UserOrderView.vue?vue&type=template&id=5199ec0c&scoped=true"
import script from "./UserOrderView.vue?vue&type=script&lang=js"
export * from "./UserOrderView.vue?vue&type=script&lang=js"

import "./UserOrderView.vue?vue&type=style&index=0&id=5199ec0c&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5199ec0c"]])

export default __exports__